import React from "react";
import { Avatar, Tooltip } from "antd";
import { getTextColorBasedOnBg } from "@utils/color_utils";

// Pure — the stacked status-count avatars shared by the player card and the header.
// Dedupes the identical cluster from PlayerCard + PlayerHeader.
export const StatusAvatarGroup = ({ counts, maxVisible = 3, size = 22, keyPrefix = "" }) => {
    if (!counts || counts.length === 0) return null;
    const visible = counts.slice(0, maxVisible);
    const hidden = counts.slice(maxVisible);

    const hiddenTooltip = hidden.map(([status, count], idx) => (
        <div key={`hidden-${keyPrefix}-${idx}`}>
            <span style={{ width: 10, height: 10, backgroundColor: status.color }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <span>{` ${status.name}: ${count}`}</span>
        </div>
    ));

    return (
        <Avatar.Group size={size} style={{ display: "flex", flexDirection: "column" }}>
            {visible.map(([status, count], idx) => {
                const statusColor = status?.color || "black";
                const statusName = status?.name || "";
                return (
                    <Tooltip title={`${statusName}: ${count}`} key={`visible-${keyPrefix}-${idx}`}>
                        <Avatar
                            style={{
                                backgroundColor: statusColor,
                                color: getTextColorBasedOnBg(statusColor),
                            }}
                            key={`${keyPrefix}_avatar_${idx}`}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                );
            })}
            {hidden.length > 0 && (
                <Tooltip title={hiddenTooltip}>
                    <Avatar>+{hidden.length}</Avatar>
                </Tooltip>
            )}
        </Avatar.Group>
    );
};
